export enum FAQActionTypes {
  FETCH = '@faq/fetch',
  FETCH_STARTED = '@faq/fetch/started',
  FETCH_SUCCEED = '@faq/fetch/succeed',
  FETCH_FAILED = '@faq/fetch/failed',
}
